import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import {catchError, from, Observable, switchMap, throwError, tap} from 'rxjs';

//import { Auth } from '@aws-amplify/auth';

import { fetchAuthSession } from 'aws-amplify/auth';
import { Router, ɵafterNextNavigation } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return from(fetchAuthSession()).pipe(
      switchMap((auth: any) => {
        //console.log("session", auth) ;
        if (!auth.tokens?.idToken) {
          return next.handle(request);
        }

        const jwt: string = auth.tokens.idToken.toString();
        //console.log("jwt", jwt) ;
        const authRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${jwt}`,
          },
        });
        
        return next.handle(authRequest);
        /*
        return next.handle(authRequest).pipe( tap(() => {},
          (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            this.router.navigate(['signin']);
          }
        }));
        */
      }),
      catchError((err:any) => {

        if (err instanceof HttpErrorResponse) {
          if (err.status == 401) {
            this.router.navigate(['signin']);
          }
        }
        
        return next.handle(request);
       
        //return throwError(() => new Error(err));
      })
    );
  }
  
}


